import { jsx as _jsx } from "react/jsx-runtime";
import { cn } from "../lib/cn.js";
function MessageGroup({ className, ...props }) {
    return (_jsx("div", { "data-slot": "message-group", className: cn("flex min-w-0 flex-col gap-2", className), ...props }));
}
function Message({ className, align = "start", ...props }) {
    return (_jsx("div", { "data-slot": "message", "data-align": align, className: cn("group/message relative flex w-full min-w-0 gap-2 text-sm data-[align=end]:flex-row-reverse", className), ...props }));
}
function MessageAvatar({ className, ...props }) {
    return (_jsx("div", { "data-slot": "message-avatar", className: cn("flex w-fit min-w-8 shrink-0 items-center justify-center self-end overflow-hidden rounded-full bg-muted group-has-data-[slot=message-footer]/message:-translate-y-8", className), ...props }));
}
function MessageContent({ className, ...props }) {
    return (_jsx("div", { "data-slot": "message-content", className: cn("flex w-full min-w-0 flex-col gap-2.5 wrap-break-word group-data-[align=end]/message:*:data-slot:self-end", className), ...props }));
}
function MessageHeader({ className, ...props }) {
    return (_jsx("div", { "data-slot": "message-header", className: cn("flex max-w-full min-w-0 items-center px-3 text-xs font-medium text-muted-foreground group-has-data-[variant=ghost]/message:px-0", className), ...props }));
}
function MessageFooter({ className, ...props }) {
    return (_jsx("div", { "data-slot": "message-footer", className: cn("flex max-w-full min-w-0 items-center px-3 text-xs font-medium text-muted-foreground group-has-data-[variant=ghost]/message:px-0 group-data-[align=end]/message:justify-end", className), ...props }));
}
export { MessageGroup, Message, MessageAvatar, MessageContent, MessageFooter, MessageHeader, };
//# sourceMappingURL=message.js.map